import type { NuxtUiTheme } from '../types/nuxt-ui-theme';

export default {
    variants: {
        variant: {
            neomorphic: {
                root: 'w-full',
                list:
                    'relative flex items-stretch gap-1 w-full p-[0.35rem] rounded-[6.188rem] border ' +
                    'border-(--white-alpha-08) bg-(image:--surface-dark-pill-bg) shadow-(--surface-dark-pill-shadow)',
                indicator:
                    'absolute left-0 top-[0.35rem] bottom-[0.35rem] w-(--reka-tabs-indicator-size) ' +
                    'translate-x-(--reka-tabs-indicator-position) rounded-(--border-radius-xl) border ' +
                    'border-(--white-alpha-10) ' +
                    'bg-[linear-gradient(145deg,var(--white-alpha-12),var(--white-alpha-04))] backdrop-blur-[0.5rem] ' +
                    'shadow-[0_0.125rem_0.5rem_rgba(0,0,0,0.25),inset_0_0.063rem_0_rgba(255,255,255,0.12),inset_0_-0.063rem_0_rgba(0,0,0,0.15)] ' +
                    'transition-[translate,width] duration-350 ease-[cubic-bezier(0.25,0.8,0.25,1)]',
                trigger:
                    'relative z-1 flex flex-1 items-center justify-center gap-[0.45rem] whitespace-nowrap ' +
                    'text-center font-(family-name:--primary-font) text-sm font-medium tracking-[-0.01em] ' +
                    'cursor-pointer rounded-(--border-radius-xl) border-0 bg-transparent px-4 py-[0.6rem] ' +
                    'text-(--white-alpha-45) outline-none transition-[color,background,box-shadow,text-shadow] ' +
                    'duration-300 ease-[cubic-bezier(0.25,0.8,0.25,1)] ' +
                    'hover:not-data-[state=active]:not-disabled:text-(--white-alpha-66)! ' +
                    'hover:not-data-[state=active]:not-disabled:[text-shadow:0_0_0.35rem_rgba(255,255,255,0.08)] ' +
                    'hover:not-data-[state=active]:not-disabled:bg-[linear-gradient(145deg,var(--white-alpha-03),var(--white-alpha-012))] ' +
                    'data-[state=active]:text-(--pure-white) data-[state=active]:font-semibold ' +
                    'data-[state=active]:[text-shadow:0_0_0.75rem_rgba(255,255,255,0.15)] ' +
                    'focus-visible:shadow-[0_0_0_0.125rem_rgba(148,163,184,0.3)] disabled:text-(--white-alpha-18) ' +
                    'disabled:cursor-not-allowed disabled:opacity-55',
                leadingIcon:
                    'text-current opacity-70 transition-opacity duration-300 ease-[cubic-bezier(0.25,0.8,0.25,1)] ' +
                    'group-data-[state=active]:opacity-100',
                leadingAvatar:
                    'rounded-(--border-radius-xl) ' +
                    'shadow-[inset_0.063rem_0.063rem_0.188rem_rgba(0,0,0,0.25),inset_-0.063rem_-0.063rem_0.188rem_rgba(60,70,90,0.15)]',
                label: 'font-(family-name:--primary-font) tracking-[-0.01em]',
                trailingBadge:
                    'rounded-(--border-radius-xl) border border-(--white-alpha-06) ' +
                    'bg-[linear-gradient(145deg,var(--white-alpha-08),var(--white-alpha-03))] px-2 py-[0.2rem] ' +
                    'font-(family-name:--primary-font) text-[0.7rem] font-semibold leading-none tracking-[0.02em] ' +
                    'text-(--white-alpha-55) ' +
                    'shadow-[inset_0.063rem_0.063rem_0.188rem_rgba(0,0,0,0.18),inset_-0.063rem_-0.063rem_0.188rem_rgba(60,70,90,0.1)] ' +
                    'transition-[color,background] duration-300 ease-[cubic-bezier(0.25,0.8,0.25,1)] ' +
                    'group-data-[state=active]:text-(--white-alpha-88) ' +
                    'group-data-[state=active]:bg-[linear-gradient(145deg,rgba(255,255,255,0.14),var(--white-alpha-06))]',
                content:
                    'mt-4 rounded-(--border-radius-xl) border border-(--white-alpha-65) p-5 ' +
                    'bg-(image:--surface-frosted-bg) backdrop-blur-[1rem] backdrop-saturate-[1.3] ' +
                    'font-(family-name:--primary-font) text-[0.925rem] text-(--input-neumorphic-text) ' +
                    'shadow-[inset_0.188rem_0.188rem_0.5rem_rgba(163,177,198,0.2),inset_-0.188rem_-0.188rem_0.5rem_rgba(255,255,255,0.55),0_0.063rem_0.188rem_rgba(0,0,0,0.04)] ' +
                    'animate-neomorphic-tabs-fade-in'
            }
        }
    }
} satisfies NuxtUiTheme['tabs'];
